import { EMenuActionsTypes } from './enums';

export const getDeleteConfirmText = (isParentFolder?: boolean) => {
	return {
		text: `Are you sure you want to delete the ${isParentFolder ? 'folder' : 'subfolder'}?`,
		description: `Deleting this ${isParentFolder ? 'folder' : 'subfolder'} will delete all its content including files.`,
	};
};

export const searchTooltipText = 'Search by file or folder name';

export const getExportMenuActions = ({
	isSearchResultsDisabled,
}: {
	isSearchResultsDisabled: boolean;
}) => [
	{
		text: 'Search results',
		id: EMenuActionsTypes.searchResults,
		disabled: isSearchResultsDisabled,
	},
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
	},
];
